import React, { useState, Suspense } from 'react';
import OrderStats from 'features/crm/components/orders/OrderStats';
import OrdersList from 'features/crm/components/orders/OrdersList';
import Tooltip from 'shared/ui/Tooltip';
import Loading from 'shared/ui/Loading';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { Info } from 'lucide-react';




const Orders = () => {
  const { currentColor } = useStateContext();

  return (
    <>
      <Suspense fallback={<Loading/>}>

      <div className='bg-gray-100 py-4 px-6 flex justify-between items-center relative'>
        <div className='flex items-center relative'>
          <Tooltip trigger='click' className='mr-2'>
            <button className='text-gray-700 hover:text-gray-900 mr-2 mt-1'>
              <Info size={20} />
            </button>
          </Tooltip>
          <h1 className='text-2xl font-bold'>Заказы</h1>
          
        </div>
      </div>
        <OrderStats/>
        <OrdersList/>
      </Suspense>
    </>
  );
};

export default Orders;
